import { render, staticRenderFns } from "./FileSuffix.vue?vue&type=template&id=5c892016"
import script from "./FileSuffix.vue?vue&type=script&lang=js"
export * from "./FileSuffix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports